"use client";

import { useCartStore } from "../store/useCartStore";
import { toast } from "sonner";
import { CartHeader, CartItemsList, CartFooter, EmptyCartState } from "./Cart";
// import { useNavigate } from "@tanstack/react-router";

export function PlansCart() {
  const { items, removeItem, clearCart, getTotalPrice, getItemCount } =
    useCartStore();
  // const navigate = useNavigate();
  const totalPrice = getTotalPrice();
  const itemCount = getItemCount();

  // const handleCheckout = () => {
  //   if (itemCount === 0) {
  //     toast.error("Cart is Empty", {
  //       description: "Please add items to your cart before checking out.",
  //       position: "top-center",
  //     });
  //     return;
  //   }

  //   // TODO: Implement actual checkout logic
  //   toast.success("Checkout Initiated", {
  //     description: `Processing checkout for ${itemCount} item${itemCount > 1 ? "s" : ""} totaling $${totalPrice.toLocaleString()}/mo`,
  //     position: "top-center",
  //   });
  //   navigate({ to: "/plans/billing" });
  // };
  const handleRemoveItem = (itemId: string) => {
    removeItem(itemId);
    toast.info("Item Removed", {
      description: "Item has been removed from your cart.",
    });
  };
  const handleClearAll = () => {
    clearCart();
    toast.info("Cart Cleared", {
      description: "All items have been removed from your cart.",
    });
  };

  return (
    <div className="mx-auto flex h-full min-h-[500px] w-full min-w-[412px] flex-col">
      <CartHeader itemCount={itemCount} onClearAll={handleClearAll} />

      <div className="scrollbar-thin flex flex-1 flex-col justify-between overflow-hidden">
        <div
          className="scrollbar-thin flex-1 overflow-y-auto p-3"
          style={{ scrollbarGutter: "stable" }}
        >
          {itemCount === 0 ? (
            <EmptyCartState />
          ) : (
            <CartItemsList items={items} onRemoveItem={handleRemoveItem} />
          )}
        </div>

        <CartFooter
          itemCount={itemCount}
          totalPrice={totalPrice}
          // onCheckout={handleCheckout}
        />
      </div>
    </div>
  );
}
